import { render, staticRenderFns } from "./RL5000.vue?vue&type=template&id=e6036b3c&scoped=true"
import script from "./RL5000.vue?vue&type=script&lang=js"
export * from "./RL5000.vue?vue&type=script&lang=js"
import style0 from "./RL5000.vue?vue&type=style&index=0&id=e6036b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6036b3c",
  null
  
)

export default component.exports